<script>
    import TheGuaranteeList from "@main/packages/TheGuaranteeList";
    import { GUARANTEE_BREAKPOINT } from "@khalatentse/settings/breakpoints";

    export default {
        name: "GuaranteeList",
        components: { TheGuaranteeList },
        data() {
            return {
                breakpoints: GUARANTEE_BREAKPOINT,
            };
        },
    };
</script>

<template>
    <the-guarantee-list
        :breakpoints="breakpoints"
        text-for-brand="Халатенце"
        text-for-year="1 год"
    ></the-guarantee-list>
</template>
